import React, { FC } from 'react';
import StatisticsPage from './statistics-page';
import { Route, Routes } from 'react-router-dom';

const StatisticsIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<StatisticsPage />} />
    </Routes>
  );
};

export default StatisticsIndex;
